export default __webpack_public_path__ + "static/media/title_ginasbar.e3066fe3.png";